var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderSystemicoComponent',{staticClass:"header_nav__active p-0",attrs:{"id":"systemico_header","variant":"blue","menuActive":true,"lang":"EN","country":"USA","loginURL":"https://systemico.net/login"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }